<div class="login-page d-flex justify-content-center align-items-center min-vh-100">
  <div class="card shadow-lg" style="width: 400px;">
    <div class="card-body text-center p-5">
      <img src="{{ logoPath }}" alt="Company Logo" class="mb-4" style="max-height: 80px;">
      
      <div *ngIf="isLoading" class="loading-container">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <h5 class="text-muted">{{ loadingMessage }}</h5>
        <p class="text-muted small">Please wait...</p>
      </div>

      <div *ngIf="!isLoading && showManualLogin" class="manual-login">
        <h4 class="mb-4">Welcome to Engenuity</h4>
        <p class="text-muted mb-4">Click below to proceed with secure login</p>
        <button class="btn btn-primary btn-lg w-100" (click)="initiateLogin()">
          <i class="fas fa-sign-in-alt me-2"></i>
          Login with IDS
        </button>
      </div>

      <div *ngIf="errorMessage" class="alert alert-danger mt-3">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ errorMessage }}
        <button class="btn btn-sm btn-outline-danger ms-2" (click)="retryLogin()">
          Retry
        </button>
      </div>
    </div>
  </div>
</div>